import { Component } from '@angular/core';
import { BaseComponent, HeaderComponent, SideNavComponent } from '@lib/components';
import { ScrollService } from '@lib/services/scroll.service';
import { RouterModule } from '@angular/router';
import { AngularMaterialModule } from 'src/app/material.module';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
    standalone: true,
    imports: [RouterModule, AngularMaterialModule, SideNavComponent, HeaderComponent],
    selector: 'app-home',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent extends BaseComponent {
    protected isWelcomeScreen = false;
    protected isCollapseNav = false;

    constructor(private readonly scrollService: ScrollService, private breakpointObserver: BreakpointObserver) {
        super();

        this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((result) => {
            this.isCollapseNav = result.matches;
        });
    }

    protected matDrawerContentScroll(event: Event): void {
        const matDrawerContent: HTMLElement = event.target as HTMLElement;
        const targetScrollBottom: number = matDrawerContent.scrollTop + matDrawerContent.clientHeight + 50;
        if (targetScrollBottom >= matDrawerContent.scrollHeight) this.scrollService.bottomReached();
    }

    onCollapseStatusChange(event: { isCollapseNav: boolean; isMobile: boolean }) {
        this.isCollapseNav = event.isCollapseNav || event.isMobile;
    }
}
